import script from "./secondary-support-case-reasons-single-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./secondary-support-case-reasons-single-select.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__